<template>
  <v-card min-width="250px" elevation="12">
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title v-if="!linkSent"> Password Reset </v-toolbar-title>
      <v-spacer />
      <v-btn icon><v-icon>mdi-help-circle-outline</v-icon></v-btn>
      <v-btn v-if="linkSent" text dark @click="linkSent = false"
        ><v-icon>mdi-arrow-left</v-icon>Back</v-btn
      >
    </v-toolbar>
    <v-card-text>
      <v-form
        v-if="!linkSent"
        class="pa-4"
        v-model="valid"
        @submit.prevent="sendResetLink"
        ref="form"
      >
        <v-alert v-model="alert" type="error" dense dismissible>{{
          errorMessage
        }}</v-alert>
        <v-text-field
          :value="passwordResetEmail"
          v-model.trim="email"
          :rules="[rules.email, rules.required]"
          outlined
          label="Email"
          hint="The email address associated with your account"
        ></v-text-field>
        <v-card-actions>
          <v-spacer />
          <v-btn type="submit" @click="validate">Send email</v-btn>
        </v-card-actions>
      </v-form>
      <v-container v-if="linkSent">
        <v-row class="text-center">
          <v-col>
            <span
              >An email was sent to <strong>{{ this.email }}</strong> with your
              password reset link!</span
            >
          </v-col>
        </v-row>
        <v-dialog v-model="dialog" width="600">
          <v-card>
            <v-card-title class="display-1"> Email Tips </v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item v-for="(tip, i) in emailTips" :key="i">
                  <v-list-item-content>
                    <v-list-item-title class="title">{{
                      tip.title
                    }}</v-list-item-title>
                    {{ tip.body }}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="dialog = false" color="primary" text large>
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <span
          >Can't find the email? <a @click="dialog = true">Click here</a></span
        >
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
const firebase = require('@/firebaseConfig')
export default {
  name: 'ResetPasswordForm',
  computed: {
    passwordResetEmail() {
      return this.$store.getters.passwordResetEmail
    },
  },
  data: () => ({
    linkSent: false,
    email: null,
    valid: false,
    errorMessage: '',
    alert: false,
    dialog: false,
    rules: {
      required: (value) => !!value || 'Required.',
      email: (value) => {
        const pattern =
          /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g
        return pattern.test(value) || 'Must be a valid email'
      },
    },
    emailTips: [
      {
        title: 'Check your spam folder',
        body: "Often times, if you aren't getting an email, it's likely in the spam folder. Check this first!",
      },
      {
        title: 'Be patient',
        body:
          'Often times email is very slow and your request will get pushed back, most of the time it is fast, but ' +
          'sometimes it can take longer.',
      },
      {
        title: "Don't spam the email system",
        body:
          'Not only does it make it slower for everyone else, but it also makes it slower for you. Please on send' +
          ' 2-3 max per hour, it is also likely the older emails will have a bad validation link anyways.',
      },
      {
        title: 'Email Format',
        body:
          'If you are wondering what the email looks like, it will ask you to follow a link to reset your password.' +
          'The link is supposed to be very long, and you be prompted to enter your new password.',
      },
      {
        title: 'If nothing is working',
        body:
          "Usually the email system is pretty robust that's not to say that it is perfect, something things happen " +
          'so if you have tried all of the above and are still having trouble, contact support.',
      },
    ],
  }),
  methods: {
    validate() {
      this.$refs.form.validate()
    },
    sendResetLink() {
      this.validate()
      if (this.valid) {
        firebase.auth
          .sendPasswordResetEmail(this.email)
          .then(() => {
            this.linkSent = true
          })
          .catch((err) => {
            this.errorMessage = err.message
            this.alert = true
          })
      }
    },
  },
}
</script>

<style scoped></style>
